// src/App.js
import React from "react";
import { GlobalStyles } from "./styles/globalStyles";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Team from "./components/Team";
import VideoSection from "./components/VideoSection";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <GlobalStyles />
      <Header />
      <Hero />
      <About />
      <Services />
      <VideoSection />
      <Team />
      <Contact />
      <Footer />
    </>
  );
}

export default App;